import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiURL from '../Api/Api';

const SuperAdminSidebar = ({ activeTab, onTabChange }) => {
  const navigate = useNavigate();
  
  const items = [
    { id: 'overview', label: 'Overview', icon: 'OV' },
    { id: 'companies', label: 'Companies', icon: 'CO' },
    { id: 'packages', label: 'Packages', icon: 'PK' },
    { id: 'coupons', label: 'Coupons', icon: 'CP' },
    { id: 'chathelp', label: 'Chat Help', icon: 'CH' },
    { id: 'incidents', label: 'Incidents', icon: 'IN' },
    { id: 'superadmins', label: 'Super Admins', icon: 'SA' },
  ];

  const handleLogout = async () => {
    try {
      const response = await fetch(`${ApiURL}/logout.php`, {
        method: 'POST',
        credentials: 'include',
      });
      localStorage.clear();
      
      if (response.ok) {
        toast.success('Logged out successfully');
        navigate('/');
      } else {
        throw new Error('Logout failed');
      }
    } catch (error) {
      console.error('Logout error:', error);
      localStorage.clear();
      toast.info('Session cleared');
      navigate('/');
    }
  };

  return (
    <aside className="w-full lg:w-72 shrink-0 border-r border-slate-200 bg-white px-5 py-6 text-slate-800 shadow-xl lg:min-h-screen flex flex-col">
      <div className="mb-10">
        <div className="text-xs font-bold uppercase tracking-[0.24em] text-brand-700">Algo2botTxn</div>
        <h1 className="mt-3 text-2xl font-black text-slate-950">Super Admin</h1>
        <p className="mt-2 text-sm font-medium text-slate-500">Packages, company growth, and platform health in one place.</p>
      </div>

      <nav className="space-y-2 flex-1">
        {items.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onTabChange(item.id)}
              className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm font-bold transition ${
                isActive ? 'bg-brand-600 text-white shadow-lg shadow-brand-600/20' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-950'
              }`}
            >
              <span className={`flex h-7 w-7 items-center justify-center rounded-lg text-xs font-black ${
                isActive ? 'bg-white/15 text-white' : 'bg-slate-100 text-slate-500'
              }`}>{item.icon}</span>
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* Logout Button */}
      <button
        onClick={handleLogout}
        className="mt-6 flex w-full items-center gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-left text-sm font-bold text-red-700 transition hover:bg-red-100"
      >
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-red-100 text-xs font-black text-red-700">LO</span>
        <span>Logout</span>
      </button>
    </aside>
  );
};

export default SuperAdminSidebar; 
